/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  faExclamationTriangle,
  faPowerOff,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import { useState } from 'react';
import { Message } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import styles from './MotoboyReset.module.scss';

import useModal from '@/hooks/util/useModal';
import { colors } from '@/Themes/Colors';
import Requests from '@/Services/Requests';

interface MotoboyResetProps {
  onClose(needUpdate: boolean): void;
  motoboyId: string;
}

function MotoboyReset({ onClose, motoboyId }: MotoboyResetProps) {
  const [hasConfirmedContinue, setHasConfirmedContinue] = useState(false);
  const [loadingMotoboyReset, setLoadingMotoboyReset] = useState(false);

  const Modal = useModal({ maxHeight: undefined });

  async function motoboyReset() {
    setLoadingMotoboyReset(true);
    let needUpdate: boolean = false;

    try {
      const response: any = await Requests.motoboys.motoboyReset(motoboyId);

      if (response.r) {
        needUpdate = true;
        toast.success(`Entregador resetado com sucesso!`);
      } else {
        toast.warn(response.errors.join(' - '));
      }
    } catch (err: any) {
      const errorMessage = err.response?.data.errors.join(' - ');
      toast.error(errorMessage);
    } finally {
      setLoadingMotoboyReset(false);
      onClose(needUpdate);
    }
  }

  return (
    <Modal
      title="Resetar Entregador"
      open
      onClose={onClose}
      closeOnDimerClick
      width="43.75rem"
    >
      <Message
        icon={
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color={colors.danger20}
            size="3x"
            style={{ margin: '1.25rem 1.25rem 1.25rem 0' }}
          />
        }
        error
        header="Cuidado"
        content={
          <div className="mgn-top-sm">
            <p>
              Este é um recurso que pode ocasionar problemas nas entregas que
              estiverem sendo realizadas no momento pelo entregador, portanto
              deve ser utilizado com cuidado.
            </p>

            <ButtonMain
              textFirst="continuar mesmo assim"
              noBorder
              style={{ padding: 0, marginLeft: 'auto', fontSize: '0.875rem' }}
              onClick={() => setHasConfirmedContinue(true)}
              disabled={hasConfirmedContinue}
            />
          </div>
        }
      />

      {hasConfirmedContinue ? (
        <ButtonMain
          textFirst="resetar"
          textEnd="entregador"
          firstStrong
          icon={faPowerOff}
          className={styles.action}
          onClick={motoboyReset}
          loading={loadingMotoboyReset}
          disabled={loadingMotoboyReset}
        />
      ) : null}
    </Modal>
  );
}

export default MotoboyReset;
